export const ANIMATION_DURATION_MS = 300;
export const FAST_ANIMATION_DURATION_MS = 200;
export const ANIMATION_TIMING_FUNCTION = "cubic-bezier(0.4, 0, 0.2, 1)";

export const BUTTON_MIN_WIDTH_REQUIRED = 165;
export const BUTTON_RIGHT_OFFSET = 126;
export const BUTTON_MIN_WIDTH_COLLAPSED = 48;
export const BUTTON_MIN_HEIGHT = 37;

export const AUTOCOMPLETE_WIDTH = 350;
export const AUTOCOMPLETE_TRANSFORM_X = 24;
export const AUTOCOMPLETE_Z_INDEX = 2000;

export const LIST_ITEM_HEIGHT = 32;

export const TOOLTIP_DELAY_MS = 1000;
export const BUTTON_TOOLTIP_DELAY_MS = 500;

export const DEFAULT_COUNTRY_CODE = "999";
export const SUPPORT_URL = "https://support.similarweb.com/hc/en-us/search?query=Projects";

const AI_TRAFFIC_PAGE = "digitalsuite_llm_solutions_aitraffic";

export const PAGE_CREATION_BLACK_LIST = [AI_TRAFFIC_PAGE];
